import React, { useEffect, useState } from "react";
import { LineChart, Line, ResponsiveContainer } from "recharts";
import axios from "axios";
import { API } from "@/lib/lifi";

function Sparkline({ data, up }) {
  if (!data || !data.length) return null;
  const pts = data.map((y, i) => ({ i, y }));
  return (
    <div className="w-16 h-6 opacity-90">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={pts}>
          <Line
            type="monotone"
            dataKey="y"
            stroke={up ? "#059669" : "#FF6161"}
            strokeWidth={1.4}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default function MarketStrip() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let cancel = false;
    const fetchIt = async () => {
      try {
        const r = await axios.get(`${API}/markets`);
        if (!cancel) setRows(r.data?.data || []);
      } catch {}
    };
    fetchIt();
    const id = setInterval(fetchIt, 60_000);
    return () => {
      cancel = true;
      clearInterval(id);
    };
  }, []);

  if (!rows.length) {
    return (
      <div className="border-y border-[var(--border)] bg-[var(--bg-elev)]">
        <div className="max-w-[1440px] mx-auto px-5 lg:px-8 h-11 flex items-center gap-3 text-[12px] text-[var(--text-subtle)]">
          <span className="w-1.5 h-1.5 rounded-full bg-[var(--text-subtle)]" />
          Loading market data…
        </div>
      </div>
    );
  }

  const items = [...rows, ...rows];
  return (
    <div className="border-y border-[var(--border)] bg-[var(--bg-elev)] overflow-hidden marquee">
      <div className="marquee-track flex items-center gap-8 py-2.5 px-5 lg:px-8 whitespace-nowrap min-w-max">
        {items.map((r, i) => {
          const up = (r.change24h ?? 0) >= 0;
          return (
            <div key={`${r.id}-${i}`} className="flex items-center gap-2.5 text-[12px]">
              <img src={r.image} alt="" className="w-4 h-4 rounded-full" />
              <span className="font-semibold text-[var(--text)]">{r.symbol}</span>
              <span className="num-sm text-[var(--text)]">
                ${r.price >= 100 ? r.price.toLocaleString(undefined, { maximumFractionDigits: 0 }) : r.price?.toFixed(r.price < 1 ? 4 : 2)}
              </span>
              <span className={`num-sm ${up ? "text-[var(--up)]" : "text-[var(--down)]"}`}>
                {up ? "▲" : "▼"} {Math.abs(r.change24h ?? 0).toFixed(2)}%
              </span>
              <Sparkline data={r.spark} up={up} />
              <span className="w-px h-3 bg-[var(--border)] mx-2" />
            </div>
          );
        })}
      </div>
    </div>
  );
}
